import styled from 'styled-components';

export const Container = styled.figure`
    width: 100%;


    >div {
        display: grid;
        justify-content: center;
        align-items: center;
        img {
            width: 200px;
            margin-top: 20px;

        }

        > h1 {
            font-weight: 600;
            text-align: center;
            color: var(--strong-pink);
            margin-top: 20px;
            font-size: 36px;
            text-transform: uppercase;
            font-family: Arial, Helvetica, sans-serif;
        }
    }

    section {
        padding: 50px;
        display: flex;
        justify-content: space-evenly;
        flex-wrap: wrap;

        div {
            background: var(--white);
            border: 1px solid var(--light-pink);
            border-radius: 5px;
            flex: 0 1 calc(20%);
            padding: 25px;
            margin: 5px;
            width: 400px;
            
            h2 {
                font-family: Arial, Helvetica, sans-serif;
                font-size: 20px;

                &::after {
                    content: '';
                    margin: 5px 0 15px 0;
                    display:block;
                    width: 50px;
                    height: 2.5px;
                    background: var(--light-pink);
                }
            }

            p {
                font-family: Arial, Helvetica, sans-serif;
            }
        }
    }
`;